<template>
  <el-dialog title="订购服务"
    :visible.sync="visible"
    width="400px"
    @close='handleClose'
    :close-on-press-escape="false">
    <el-form v-loading="loading"
      :model="order"
      :rules="rules"
      ref="ruleForm"
      label-width="90px">
      <el-form-item label="增值服务:">
        {{vacId | vasMap()}}
      </el-form-item>
      <el-form-item label="有效期:"
        prop="daterange">
        <el-date-picker style="width: 100%"
          v-model="order.daterange"
          type="daterange"
          range-separator=""
          unlink-panels
          :picker-options="options"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button @click="handleSubmit(1)"
        :loading="loading">试用</el-button>
      <el-button type="primary"
        @click="handleSubmit(0)"
        :loading="loading">订购</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'order-modal',
  components: {},
  props: {
    vendorId: [String, Number],
    vacId: [String, Number], // 1，物流；2，小程序；3，新零售
    callback: [Function]
  },
  data () {
    return {
      loading: false,
      visible: false,
      order: {
        daterange: ''
      },
      minDate: null,
      maxDate: null,
      options: {
        disabledDate: (time) => {
          const start = new Date()
          start.setDate(start.getDate() - 1)
          return time.getTime() < start
        }
      },
      rules: {
        daterange: [
          { required: true, message: '请选择有效期', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit (trialFlag) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          let post = (trialFlag === 1
            ? {
              trialBeginTime: +this.order.daterange[0],
              trialEndTime: +this.order.daterange[1]
            }
            : {
              validTime: +this.order.daterange[0],
              expirationTime: +this.order.daterange[1]
            })
          this.$store.dispatch('vacorder/addvacorder', {
            payload: {
              vendorId: this.vendorId,
              vacId: this.vacId,
              trialFlag,
              ...post
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
